module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/97a6a5331c2fa8dbe8d0f8d26fc254b7.png";